export const SET_VALIDATE_ACCOUNT_PARAMETERS = 'SET_VALIDATE_ACCOUNT_PARAMETERS';
